function pad(n: number): string {
  return String(n).padStart(2, '0');
}

function localDate(now: Date): string {
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

/** Today as a YYYY-MM-DD calendar date in the event's zone. Before a zone is
 *  known (or for one the browser does not recognise) it is the browser's own
 *  date, which is what the person typing is looking at. */
export function todayInZone(timeZone: string, now: Date = new Date()): string {
  if (!timeZone) return localDate(now);
  try {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(now);
  } catch {
    return localDate(now);
  }
}

/** A YYYY-MM-DD calendar date moved by whole days, with no zone involved. */
export function shiftDate(date: string, days: number): string {
  const [y, m, d] = date.split('-').map(Number);
  const moved = new Date(Date.UTC(y, m - 1, d + days));
  return moved.toISOString().slice(0, 10);
}

export function daysBetween(from: string, to: string): number {
  const ms = (date: string) => Date.parse(`${date}T00:00:00Z`);
  return Math.round((ms(to) - ms(from)) / 86_400_000);
}
